import { render, staticRenderFns } from "./QuestionandAnswers.vue?vue&type=template&id=81d16d82&scoped=true"
import script from "./QuestionandAnswers.vue?vue&type=script&lang=js"
export * from "./QuestionandAnswers.vue?vue&type=script&lang=js"
import style0 from "./QuestionandAnswers.vue?vue&type=style&index=0&id=81d16d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d16d82",
  null
  
)

export default component.exports